import React from "react";
import "./scss/Tabs.scss";

const TabsHeader = ({ tabs, activeTab, onTabChange, className = "" }) => {
  return (
    <div className={`row tab-header ${className}`}>
      {tabs.map((tab, index) => (
        <div key={index} className="col">
          <a
            className={`tab-element ${activeTab === index ? "active" : ""}`}
            onClick={() => onTabChange(index)}
          >
            {tab.label}
          </a>
        </div>
      ))}
    </div>
  );
};

export default TabsHeader;
